<template>
    <section class="studio-finder" v-resize="resizeHandler">
        <div class="container">
            <BackButton
                    containerClass="studio-finder__btn"
                    defaultRoute="/members/dashboard"
            />
            <div class="studio-finder__info">
                <div class="studio-finder__info-top">
                    <div class="studio-finder__info-title title-h4 text-center">{{$t('members.faq.instructions__title')}}</div>
                    <div class="studio-finder__info-content text-center font-reg lg10">
                        <span v-html="$t('members.dashboard.info')"></span>
                    </div>
                </div>

                <div class="d-flex align-center ">
                    <div class="attention studio-finder__instruction">
                        <div class="d-flex align-center studio-finder__instruction-more" @click="moreInfoHandler">
                            <div v-if="actualWidth <= 599" class="studio-finder__instruction-text">
                                <p v-if="isOpenMoreInfo">{{$t("members.studio-finder.hide_info")}}</p>
                                <p v-else>{{$t("members.studio-finder.more_info")}}</p>
                            </div>
                            <div class="attention__pic"><img src="@/assets/images/dashboard/info.svg" alt=""></div>
                        </div>

                        <div class="attention__text" v-if="actualWidth >= 600 || (isOpenMoreInfo && actualWidth <=599)">
                            <div v-html="$t('members.studio-finder.instruction_1')"></div>
                            <div v-html="$t('members.studio-finder.instruction_2')"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="studio-finder__wrapper d-sm-flex justify-sm-space-between flex-wrap">
                <Dropdown
                    class="studio-finder__input studio-finder__dropdown flex xs12 sm5 md5 lg3"
                    :list="countryList"
                    placeholder="Choose a country"
                    @update="updateCountryHandler"
                    :is-need-watch="true"
                />
                <DropdownAutocomplete
                        class="studio-finder__input flex xs12 sm5 md5 lg3"
                        :placeholder="$t('members.studio-finder.city_or_postal_code')"
                        :isLocationSuggestions="true"
                        :isReset="isNeedResetAutocomplete"
                        @update="setCityLocation"

                />

                <radiusControl
                        class="studio-finder__input studio-finder__control"
                        :min="0" :max="10000"
                        @updateRadius="setCityRadius"
                        :value="COUNTRY_DATA.radius"/>

               <div class="studio-finder__action">
                   <button v-if="isNeedReset" class="studio-finder__reset btn btn-reset" @click="resetHandler" v-html="$t('members.studio-finder.reset_button')"></button>
                   <button class="studio-finder__button btn btn-gradient btn-h40 flex xs12 sm3 md3 lg7" @click="searchHandler">
                       <span v-html="$t('members.studio-finder.search_button')"></span>
                   </button>
               </div>

            </div>
            <Table
                :table-head="head"
                :table-body="body"
                :table-data="tableData"
                :request-function="searchStudiosFunction"
                moreMode="tablet"
                :isHover="true"
                :isMapOpen="true"
                :options="options"
            />
        </div>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { searchStudios, countryCityList } from "@/api/clientServices";
    import Table from "@/elements/Table/Table";
    import Dropdown from "@/elements/Dropdown";
//    import SimpleInput from "@/elements/SimpleInput";
    import radiusControl from '@/elements/radiusControl'
    import resize from "@/mixins/resize";
    import DropdownAutocomplete from "@/elements/DropdownAutocomplete";
    const DEFAULT_RADIUS = 25;
    const DEFAULT_COORDINATE = 0;

    export default {
        components: { Dropdown, Table, DropdownAutocomplete, radiusControl},
        data() {
            return {
                head: [
                    {
                        name: 'name',
                        adaptiveMode: 'mobile',
                        width: '208px'
                    },
                    {
                        name: 'postalCode',
                        adaptiveMode: 'tablet',
                        width: '70px',
                    },
                    {
                        name: 'city',
                        adaptiveMode: 'mobile',
                        width: '141px',
                    },
                    {
                        name: 'country',
                        adaptiveMode: 'tablet',
                        width: '70px',
                    }
                ],
                allCountry: [],

                cityList: [],
                countryList: [],

                currentCountry: this.$t('members.studio-finder.all_countries'),
                currentCity: this.$t('members.studio-finder.all_cities'),

                postalCode: '',

                isOpenMoreInfo: false,

                COUNTRY_DATA: {
                    latitude: DEFAULT_COORDINATE,
                    longitude: DEFAULT_COORDINATE,
                    radius: DEFAULT_RADIUS,
                },
                isNeedResetAutocomplete: false,
                isNeedReset: false,
            }
        },

        mixins: [resize],

        watch: {
          currentCountry() {
              if (this.currentCountry === this.$t('members.studio-finder.all_countries')) {
                  this.cityList = [];
              } else {
                  this.cityList = [this.$t('members.studio-finder.all_cities'), ...this.allCountry.find(item => item.id === this.currentCountry.id).cities] ;
              }
          },
            options: {
                handler(option) {
                  const {latitude, longitude, radius} = option;
                  if(radius !== DEFAULT_RADIUS || latitude !== DEFAULT_COORDINATE || longitude !== DEFAULT_COORDINATE) {
                      this.isNeedReset = true;
                  } else {
                      this.isNeedReset = false;
                  }
                }
            }
        },

        computed: {
            ...mapGetters([
                'getStudio',
                'tableData',
            ]),

            searchStudiosFunction() {
                return searchStudios
            },

            options() {
                return {
                    ...this.COUNTRY_DATA,
                    country_id: this.currentCountry === this.$t('members.studio-finder.all_countries') ? '' : this.currentCountry.id,
                }
//                return {
//                    postal_code: this.postalCode || '',
//                    city: this.currentCity === this.$t('members.studio-finder.all_cities') ? '' : this.currentCity,
//                    country_id: this.currentCountry === this.$t('members.studio-finder.all_countries') ? '' : this.currentCountry.id,
//                }
            },

            body() {
                let arr = [];

                 this.tableData.data && this.tableData.data.forEach(item => {
                    arr.push({
                        name: item.title,
                        postalCode: item.postal_code,
                        city: item.city,
                        country: item.country.title
                    })
                });

                return arr;
            }
        },

        async created() {
            // const { postal_code, city, country: { id: country_id}} = this.getStudio;

            this.$store.dispatch('PAGINATE', { page: 1, requestFunction: searchStudios, options: this.options });

            try {
                const res = await countryCityList();

                this.allCountry = res.data.data.countries;

                this.countryList.push(this.$t('members.studio-finder.all_countries'));
                this.currentCountry = this.$t('members.studio-finder.all_countries');
                this.allCountry.forEach(item => {
                    this.countryList.push(item.title);
                });

                // this.currentCountry = this.countryList[0];
            } catch (e) {
                console.log(e, 'get countryCityList error');
            }
        },

        methods: {
            updateCountryHandler(newItem) {
                if (newItem === this.$t('members.studio-finder.all_countries')) {
                    this.currentCountry = this.$t('members.studio-finder.all_countries');
                } else {
                    this.currentCountry = this.allCountry.find(item => item.title === newItem);
                }
                this.currentCity = '';
            },

            updateCityHandler(newItem) {
                this.currentCity = newItem;
            },
            setCityLocation(city) {
                let {latitude, longitude} = city;
                this.COUNTRY_DATA['latitude'] = latitude
                this.COUNTRY_DATA['longitude'] = longitude
            },
            setCityRadius(radius) {
                this.COUNTRY_DATA['radius'] = radius
            },
            resetHandler() {
                let {latitude, longitude} = this.COUNTRY_DATA;
                this.COUNTRY_DATA = {
                    latitude: DEFAULT_COORDINATE,
                    longitude: DEFAULT_COORDINATE,
                    radius: DEFAULT_RADIUS
                };
                if(latitude || longitude) {
                    this.isNeedResetAutocomplete = true
                    setTimeout(() => {this.isNeedResetAutocomplete = false}, 500)
                }


            },

            searchHandler() {
                this.$store.dispatch('PAGINATE', { page: 1, requestFunction: searchStudios, options: this.options });
            },

            moreInfoHandler() {
                if (this.actualWidth <= 599 ) {
                    this.isOpenMoreInfo = !this.isOpenMoreInfo
                }
            }
        }
    }
</script>

<style lang="sass" scoped>
    .studio-finder
        &__action
            position: relative
            +rmin(600)
                width: 100%
                margin-top: 25px
                display: flex
                justify-content: flex-end
                height: 40px
            +rmin(1264)
                width: 310px
                margin-top: 0
            +rmin(1264)
                margin-left: (156/1136)*100%
            +rmin(1904)
                margin-left: 42.863636%
            .btn + .btn
                margin: 16px 0 0 0
                +rmin(600)
                    margin: 0 0 0 14px
            .btn
                width: 100%
                +rmin(600)
                    width: auto
        &__reset
            +rmin(1264)
                position: absolute
                left: 0
                top: 50%
                transform: translateY(-50%)
        &__btn
            flex: initial

        &__wrapper
            position: relative
            z-index: 2
            margin-bottom: 24px

        &__dropdown
            &::v-deep
             .dropdown
                z-index: 2

        &__input
            &::v-deep
                .v-select__slot input
                    height: 40px
                .v-input__slot
                    margin-bottom: 0
                    height: 40px
                .v-list-item__title
                    max-width: 333px
            margin-bottom: 16px
            +rmin(600)
                max-width: 32%
                margin-bottom: 0
            +rmin(601)
                max-width: 38%
            +rmin(960)
                max-width: 100%
            +rmin(1264)
                max-width: 240px

        &__control
            +r(600)
                width: 100%

        &__instruction
            &-more
                +r(599)
                    width: calc(100vw - 24px)

            &-text
                +semi
                color: #0B234B
                opacity: 0.5
                letter-spacing: 0.005em
                font-size: 12px
                margin-right: 12px


            +r(599)
                flex-direction: column-reverse
                margin-top: 0

                .attention__text
                    margin-left: 0
                    margin-bottom: 8px

        &__button
            height: 40px

        &__info
            margin-top: 16px
            margin-bottom: 24px
            &-top
                text-align: center
                border-bottom: 1px solid rgba(1, 37, 78, 0.1)
                padding-bottom: 16px
                margin-bottom: 16px

            &-title
                color: $color--dark
                line-height: 1
                margin-bottom: 16px

            &-content
                font-size: 14px
                color: rgba(11, 35, 75, 0.6)
</style>